/**
 * Variant State
 */
export var VariantState;
(function (VariantState) {
    VariantState["PRIMARY"] = "PRIMARY";
    VariantState["SECONDARY"] = "SECONDARY";
    VariantState["TERTIARY"] = "TERTIARY";
})(VariantState || (VariantState = {}));
/**
 * Returns variant's classname depending on variant type
 * @param variantType {string} - VariantType
 * @returns {string} - Variant value
 */
export const getVariantClassName = (variantType) => {
    if (!variantType)
        return '';
    switch (variantType) {
        case 'PRIMARY':
            return 'primary';
        case 'SECONDARY':
            return 'secondary';
        case 'TERTIARY':
            return 'tertiary';
        default:
            return '';
    }
};
/**
 * Returns variant's style depending on variant type
 * @param variantType {string} - VariantType
 * @returns {string} - Variant value
 */
export const getVariantStyle = (variantType) => {
    switch (variantType) {
        case 'PRIMARY':
            return '#CC4E0A';
        case 'SECONDARY':
            return '#0C7B91';
        case 'TERTIARY':
            return '#FFFFFF';
        default:
            return '';
    }
};
//# sourceMappingURL=Variant.js.map